export const editorConfig = {
  data() {
    return {
      head: '',
      text: '',
      customText: '',
      editor: '',
      removeFilesIds: '',
      imageUrl: null,
      imageId: '',
      imagesArr: [],
      editorSettings: {
        modules: {
          toolbar: {
            container: [
              [{
                header: [false, 1, 2, 3, 4, 5, 6]
              }],
              ['undo'],['redo'],
              ['bold', 'italic', 'underline', 'strike'],
              [
                {align: ""},
                {align: "center"},
                {align: "right"},
              ],
              ["blockquote", "code-block"],
              [
                {list: 'ordered'},
                {list: 'bullet'}
              ],
              ["link", "image", "video"], ["clean"]
            ],
            handlers: {
              undo: () => {
                // document.execCommand("undo")
                if (this.position > 1) {
                  console.log('назад клик')
                  this.undoRedoFlag = true
                  this.position -= 1
                }
              },
              redo: () => {
                // document.execCommand("redo")
                if (this.position < this.history.length) {
                  console.log('вперед клик')
                  this.undoRedoFlag = true
                  this.position += 1
                }
              }
            }
          },
          imageResize: {},
          VideoResize: {
            modules: [ 'Resize', 'DisplaySize', 'Toolbar' ],
            tagName: 'iframe', // iframe | video
          }
        }
      },
      history: [],
      position: 0,
      undoRedoFlag: false
    }
  },
  watch: {
    position() {
      if (this.undoRedoFlag) {
        this.customText = this.history[this.position - 1]
        document.querySelector('.ql-editor').innerHTML = this.history[this.position - 1]
      }
    }
  },
  methods: {
    setLabels() {
      let undo = document.createElement('span');
      undo.innerHTML = this.$t("EDITOR.undo");
      document.querySelector('.ql-undo').append(undo);

      let redo = document.createElement('span');
      redo.innerHTML = this.$t("EDITOR.redo");
      document.querySelector('.ql-redo').append(redo);

      let bold = document.createElement('span');
      bold.innerHTML = this.$t("EDITOR.bold");
      document.querySelector('.ql-bold').append(bold);

      let italic = document.createElement('span');
      italic.innerHTML = this.$t("EDITOR.italic");
      document.querySelector('.ql-italic').append(italic);

      let underline = document.createElement('span');
      underline.innerHTML = this.$t("EDITOR.underline");
      document.querySelector('.ql-underline').append(underline);

      let strike = document.createElement('span');
      strike.innerHTML = this.$t("EDITOR.strike");
      document.querySelector('.ql-strike').append(strike);

      let align = document.createElement('span');
      align.innerHTML = this.$t("EDITOR.align");
      document.querySelector('.ql-align').append(align);

      let alignC = document.createElement('span');
      alignC.innerHTML = this.$t("EDITOR.alignC");
      document.querySelector('.ql-align[value=center]').append(alignC);

      let alignR = document.createElement('span');
      alignR.innerHTML = this.$t("EDITOR.alignR");
      document.querySelector('.ql-align[value=right]').append(alignR);

      let blockquote = document.createElement('span');
      blockquote.innerHTML = this.$t("EDITOR.blockquote");
      document.querySelector('.ql-blockquote').append(blockquote);

      let codeBlock = document.createElement('span');
      codeBlock.innerHTML = this.$t("EDITOR.codeBlock");
      document.querySelector('.ql-code-block').append(codeBlock);

      let listO = document.createElement('span');
      listO.innerHTML = this.$t("EDITOR.listO");
      document.querySelector('.ql-list[value=ordered]').append(listO);

      let listU = document.createElement('span');
      listU.innerHTML = this.$t("EDITOR.listU");
      document.querySelector('.ql-list[value=bullet]').append(listU);

      let link = document.createElement('span');
      link.innerHTML = this.$t("EDITOR.link");
      document.querySelector('.ql-link').append(link);

      let image = document.createElement('span');
      image.innerHTML = this.$t("EDITOR.image");
      document.querySelector('.ql-image').append(image);

      let video = document.createElement('span');
      video.innerHTML = this.$t("EDITOR.video");
      document.querySelector('.ql-video').append(video);

      let clean = document.createElement('span');
      clean.innerHTML = this.$t("EDITOR.clean");
      document.querySelector('.ql-clean').append(clean);
    }
  }
}
